import React from 'react';
import { Badge, Card, OverlayTrigger, Popover } from 'react-bootstrap';
import './TitlesCell.scss';

export interface EstablishmentRole {
    id: string | number;
    [key: string]: any;
    isResponsibility?: boolean;
}

interface JobTitleCellProps {
    title: string;
    rowId: string | number;
    establishmentRoles: EstablishmentRole[];
    fieldName: string;
    keyPrefix: string;
}

const TitlesCell: React.FC<JobTitleCellProps> = ({ title, rowId, establishmentRoles, fieldName, keyPrefix }) => {
    if (!establishmentRoles || establishmentRoles.length === 0) return null;

    const distinctValues = (() => {
        const seen = new Set();
        return establishmentRoles.filter((er) => {
            const val = er[fieldName];
            if (seen.has(val)) {
                return false;
            } else {
                seen.add(val);
                return true;
            }
        });
    })();

    const isFirstRoleClosed =
        distinctValues[0] && (distinctValues[0]['closed'] === 1 || distinctValues[0]['closed'] === true);

    return (
        <div className="title-cell">
            <Badge
                key={`primary_${keyPrefix}${rowId}`}
                className="title-badge"
                style={{
                    borderRadius: '3px',
                    textDecoration: isFirstRoleClosed ? 'line-through' : 'none',
                }}
            >
                {distinctValues[0][fieldName]}
            </Badge>
            {distinctValues.length > 1 && (
                <OverlayTrigger
                    placement="top"
                    container={document.body}
                    overlay={(overlayProps) => (
                        <Popover id="popover-basic" {...overlayProps} className="titles-popover">
                            <Popover.Content className="titles-popover-content">
                                <Card className="titles-card">
                                    <Card.Body className="titles-card-body">
                                        {title}{' '}
                                        <Badge
                                            key={`more_${keyPrefix}${rowId}`}
                                            className="titles-count-badge"
                                            style={{
                                                borderRadius: '3px',
                                            }}
                                        >
                                            {distinctValues.length}
                                        </Badge>
                                        <div className="titles-grid">
                                            {distinctValues.flatMap((er) => [
                                                <span
                                                    key={`t_${keyPrefix}${rowId}${er.id}`}
                                                    style={{
                                                        textDecoration:
                                                            er['closed'] === 1 || er['closed'] === true
                                                                ? 'line-through'
                                                                : 'none',
                                                    }}
                                                >
                                                    {er[fieldName]}
                                                </span>,
                                                <Badge
                                                    key={`rt_${keyPrefix}${rowId}${er.id}`}
                                                    className={`${er.isResponsibility ? 'responsibility' : 'role'}-type-badge`}
                                                    style={{
                                                        borderRadius: '3px',
                                                    }}
                                                >
                                                    {er.isResponsibility ? 'Responsibility' : 'Role'}
                                                </Badge>,
                                            ])}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Popover.Content>
                        </Popover>
                    )}
                >
                    <Badge
                        key={`more_${keyPrefix}${rowId}`}
                        className="titles-more-badge"
                        style={{
                            borderRadius: '3px',
                        }}
                    >
                        +{distinctValues.length - 1} more...
                    </Badge>
                </OverlayTrigger>
            )}
        </div>
    );
};

export default TitlesCell;
